/* src/app/features/irregularidade_operacao/pesquisa/listagem/irregularidade-listagem.component.scss */
#pointer :hover {
  cursor: pointer;
}
/*# sourceMappingURL=irregularidade-listagem.component.css.map */
